import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import Header from '../../components/header';
import img_titulo from '../../assets/imgs_parlamento/IMG_ABRE_PARLAMENTO.png';
import img_next from '../../assets/imgs_parlamento/NEXT_IMG_PARLAMENTO.png';
import seta from '../../assets/imgs_parlamento/ARROW.png';

const importImages = async () => {
  const images = {};
  for (let i = 1; i <= 6; i++) {
        images[`img_${i}`] = require(`../../assets/imgs_parlamento/IMG_${i}_PARLAMENTO.png`);
  }
  return images;
};

export default function ParlamentoNovaCapital() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

    const [images, setImages] = useState({});
    
    useEffect(() => {
        const loadImages = async () => {
            const imgs = await importImages();
            setImages(imgs);
        };
        loadImages();
    }, []);

    const navigate = useNavigate();
    const [isTransitioning, setIsTransitioning] = useState(false);
    const [nextText, setNextText] = useState("PRÓXIMO CONTEÚDO");

    const handleTransition = () => {
        setNextText("O PALÁCIO DO CONGRESSO NACIONAL");
        setIsTransitioning(true);
        setTimeout(() => {
            navigate('/ConstrucaoInstalacao'); 
        }, 1000); 
    }

    const [visibleSection, setVisibleSection] = useState('INTRODUÇÃO');

    const toggleVisibility = (paragrafo) => {
        setVisibleSection(paragrafo);
    };

  return (
    <div className="w-full bg-white flex flex-col justify-center font-medium font-['Lato']">
      <Header cor='branca' />

      {/* CAPA */}
      <div
          className="w-full h-auto bg-cover bg-center"
          style={{ backgroundImage: `url(${img_titulo})` }}
      >
        <div className="w-full h-screen flex flex-col justify-center pt-16 md:pt-64 gap-16 md:gap-64 px-[5vw] md:pl-24 md:pr-[33.19vw] pb-8 md:pb-28 bg-black/40">
            <div className="w-full md:w-[56.11vw]">
              <div className="w-full md:w-[56.11vw] flex-col justify-center items-start inline-flex">
                  <div className="w-full md:w-[37.56vw] text-white text-xl md:text-3xl font-light font-lato">O PALÁCIO DO CONGRESSO NACIONAL</div>
                  <div className="w-full md:w-[56.11vw] text-white text-2xl md:text-[45px] font-bold font-futura-bold">O PARLAMENTO E A NOVA CAPITAL</div>
              </div>
              <div className="w-full md:w-[28.58vw] pt-4 md:pt-6">
                <div className="pb-1 text-white text-base md:text-xl font-medium font-['Lato']">Marcos Magalhães</div>
                <div className="w-full md:w-[28.58vw] h-[0px] border border-white"></div>
                <div className="text-white text-sm md:text-base font-light font-['Lato']">Historiador e Consultor Legislativo</div>
              </div>
            </div>
            <div className="w-full md:w-[34.7vw]"> 
              <div className="w-full md:w-[34.7vw] text-white text-xs md:text-base font-medium font-['Lato'] [text-shadow:_0px_4px_4px_rgb(0_0_0_/_0.25)]">Cerimônia de assinatura da escritura pública de transferência das terras da nova capital do Estado de Goiás para a União - 18/02/1957<br/>Acervo do Arquivo Nacional</div>
            </div>
        </div>
      </div>

      {/* INTRODUÇÃO */}
      <div
          className="w-full min-h-[40vh] md:min-h-screen bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${images.img_1})` }}
      >
        <div className="w-full min-h-[40vh] md:min-h-screen py-[15vh] md:py-[23vh] px-[5vw] md:pl-[7vw] md:pr-[11.3vw] bg-black/80">
          <div className="w-full box-border gap-5 text-white flex flex-col md:flex-row items-start">
              <div className="flex md:flex-col flex-row flex-wrap gap-4 mb-4">
                  <p
                      onClick={() => toggleVisibility('INTRODUÇÃO')}
                      className={`cursor-pointer text-base md:text-lg font-normal font-['Lato'] ${
                          visibleSection === 'INTRODUÇÃO' ? 'text-white' : 'text-white/40'
                      }`}
                  >
                      INTRODUÇÃO
                  </p>
              </div>

              {visibleSection === 'INTRODUÇÃO' && (
                  <div className="w-full md:w-[64.32vw] text-white text-sm md:text-base font-medium font-['Lato'] text-justify">
                    A ideia de transferência da capital concebeu-se secularmente, mas a sua realização foi instantânea. Em três anos e meio, a cidade foi construída. O Parlamento contribuiu decisivamente por meio da elaboração do enquadramento jurídico da mudança da capital e da aprovação dos aportes financeiros necessários.<br/>Juscelino Kubitschek encaminhou ao Legislativo projeto de lei que dispunha "sobre a mudança da capital" e oferecia outras providências. 
                    Aprovado por esmagadora maioria no Senado, a proposição resultou na Lei no 1.874, de 19 de setembro de 1956, a certidão de nascimento de Brasília. A mesma norma concebeu instituto jurídico que planejou e executou a construção, a Novacap, empresa mista, nos moldes da Petrobras. Entre as poucas inovações introduzidas no projeto pelo Legislativo estava a nomeação de um representante da oposição parlamentar no Conselho de Administração da empresa.<br/><br/>A partir daí, o destino de Brasília ligou-se definitivamente ao Congresso Nacional. Iniciativa de vulto, as suas rubricas orçamentárias deveriam ser aprovadas no Parlamento. A construção da cidade entrou no jogo político, provocando a formação de grupos de pressão cujas posições atravessavam as clivagens de caráter partidário e regional: os mudancistas e os antimudancistas.
                    <br/><br/>No ano de 1957, as obras começaram em ritmo acelerado. No mesmo período, a tramitação da Lei no 3.273, de 1º de outubro de 1957, que definia o dia 21 de abril de 1960 como data de inauguração da capital, contribuiu para que o Parlamento acompanhasse o andamento dos projetos. Emenda apresentada pelos Deputados Afonso Arinos e Carlos Lacerda ventilou, pela primeira vez, a questão da autonomia política da capital.
                  </div>
              )}
          </div>
        </div>
      </div>

      {/* LEGENDA IMG 1 */}
      <div
          className="w-full min-h-[40vh] md:min-h-screen flex justify-start items-end pb-6 md:pb-24 px-[5vw] md:pl-40 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${images.img_1})`}}
      >
        <div className="w-full md:w-[27.4vw] text-white text-xs md:text-base font-medium font-['Lato']">Assinatura da Lei n.o 3.273, de 1º de outubro de 1957, que fixa a data da mudança para a nova Capital<br/>Acervo Arquivo Nacional</div>
      </div>

      {/* LEGENDA IMG 2 */}
      <div
          className="w-full min-h-[40vh] md:min-h-screen flex justify-start items-end pb-6 md:pb-28 px-[5vw] md:pl-40 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${images.img_2})`}}
      >
        <div className="w-full md:w-[27.4vw] text-white text-xs md:text-base font-medium font-['Lato']">Juscelino em sua primeira viagem a Brasília - 02/10/1956<br/>Acervo Arquivo Nacional</div>
      </div>

      {/* CITAÇÃO JK */}
      <div
          className="w-full h-auto flex justify-center items-center relative bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${images.img_3})`}}
      >
          <div className="w-full h-auto flex flex-col py-16 md:py-72 px-[5vw] md:pl-56 md:pr-[55.72vw] bg-[#5a6e64]/80">
            <div className="w-full md:w-[23.3vw] text-white text-sm md:text-base font-bold font-['Lato'] text-justify">
              "Deste Planalto Central, desta solidão que em breve se transformará em cérebro das altas decisões nacionais, lanço os olhos mais uma vez sobre o amanhã do meu país e antevejo esta Alvorada com fé inquebrantável e uma confiança sem limites no seu grande destino" <br/><br/>Juscelino Kubitscheck, 2 de dezembro de 1956
            </div>
          </div>
      </div>

      {/* IMG 3 VAZIA */}
      <div
          className="w-full min-h-[40vh] md:min-h-screen flex justify-start items-end px-[5vw] md:pl-44 pb-6 md:pb-20 bg-cover bg-center"
          style={{ backgroundImage: `url(${images.img_3})`}}
      ></div>

      {/* LEGENDA IMG 4 */}
      <div
          className="w-full min-h-[40vh] md:min-h-screen flex justify-start items-end px-[5vw] md:pl-40 pb-6 md:pb-20 bg-cover bg-center"
          style={{ backgroundImage: `url(${images.img_4})`}}
      >
        <div className="w-full md:w-[35.28vw] text-white text-xs md:text-base font-medium font-['Lato']">Juscelino na Fazenda Gama, em sua primeira viagem a Brasília - 02/10/1956<br/>Acervo Arquivo Nacional</div>
      </div>

      {/* LEGENDA IMG 5 */}
      <div
          className="w-full min-h-[40vh] md:min-h-screen flex justify-start items-start px-[5vw] md:pl-40 pt-10 md:pt-40 bg-cover bg-center relative"
          style={{ backgroundImage: `url(${images.img_5})`}}
      >
        <div className="w-full md:w-[35.28vw] text-black text-xs md:text-base font-medium font-['Lato']">JK e Israel Pinheiro examinam plantas da nova capital no Catetinho - 1956 Acervo Arquivo Nacional</div>
      </div>

      {/* LEGENDA IMG 6 */}
      <div
          className="w-full min-h-[40vh] md:min-h-screen flex justify-start items-end px-[5vw] md:pl-40 pb-6 md:pb-24 bg-cover bg-center"
          style={{ backgroundImage: `url(${images.img_6})`}}
      >
        <div className="w-full md:w-[35.28vw] text-white text-xs md:text-base font-medium font-['Lato']">Catetinho, primeira sede da Presidência da República em Brasília - 1956 Acervo Arquivo Nacional</div>
      </div>

      {/* PRÓXIMO CONTEÚDO */}
      <div
          className="w-full h-auto flex items-center bg-cover bg-center transition-all duration-1000"
          style={{ backgroundImage: `url(${img_next})` }}
      >
          <div
              className={`w-full h-screen px-[5vw] md:pl-[7vw] md:pr-[33.19vw] pt-[45.90vh] pb-[45.80vh] transition-all duration-1000 ${
                  isTransitioning ? 'bg-black/40' : 'bg-[#abb5b0]/70'
              }`}
          >
              <div className="flex gap-6">
                  <div className="flex-col justify-center items-start inline-flex">
                      <div className={`text-xl md:text-3xl font-light font-['Lato'] transition-colors duration-1000 ${isTransitioning ? 'text-white' : 'text-black'}`}>
                          {nextText}
                      </div>
                      <div className={`text-2xl md:text-[45px] font-bold font-futura-bold transition-colors duration-1000 ${isTransitioning ? 'text-white' : 'text-black'}`}>
                          CONSTRUÇÃO E INSTALAÇÃO
                      </div>
                  </div>
                  <img
                      className="w-9 h-5 ml-6 mt-auto mb-6 cursor-pointer animate-moveRight transition-transform duration-500 hover:scale-110"
                      src={seta}
                      alt='seta'
                      onClick={handleTransition}
                  />
              </div>
          </div>
      </div>
    </div>
  );
}